import {Dispatch, SetStateAction, useEffect, useState} from 'react'
import { MdmTableName, TableOptions } from '../types'
import useProjectContext from '../../hooks/useProjectContext';
import { userTableDetails } from '../utils';

export const initialFilter: TableOptions = {
  first: 0,
  rows: 10,
  page: 1,
  sortField: "",
  sortOrder: 1,
  multiSortMeta: [],
  filters: {},
  filter: null,
  andFilters: [],
  internalFilters: [],
  search: "",
  reqSortField: "",
};

function useTableFilter(tableName: MdmTableName, options: Partial<TableOptions>):[TableOptions, Dispatch<SetStateAction<TableOptions>>] {
  const { userSettings } = useProjectContext();
  const tableDetails = userTableDetails(userSettings, tableName);
  const [firstRender, setFirstRender] = useState(true);
  const [tableFilter, setTableFilter] = useState<TableOptions>({
    ...initialFilter,
    rows: tableDetails?.rows || 10,
    ...options,
  })

  useEffect(() => {
    const localStorageFilters = localStorage.getItem(tableName);
    if (localStorageFilters) {
      const filters = JSON.parse(localStorageFilters);
      setTableFilter(prevState => ({ ...prevState, ...filters }));
    }
  }, []);
 
  useEffect(() => {
    if (userSettings) {
      setTableFilter(prevState => ({ ...prevState, rows: tableDetails?.rows || 10 }));
      localStorage.setItem(tableName, JSON.stringify({...tableFilter, rows: tableDetails?.rows || 10}));
    }
  }, [userSettings]);
  
  useEffect(() => {
    if (!firstRender) {
      localStorage.setItem(tableName, JSON.stringify(tableFilter));
    }
    setFirstRender(false);
  }, [tableFilter]);



  return [tableFilter, setTableFilter];
}

export default useTableFilter;